import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './general-health.reducer';

export const GeneralHealthUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const generalHealthEntity = useAppSelector(state => state.generalHealth.entity);
  const loading = useAppSelector(state => state.generalHealth.loading);
  const updating = useAppSelector(state => state.generalHealth.updating);
  const updateSuccess = useAppSelector(state => state.generalHealth.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/general-health${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.veryGoodHealth !== undefined && typeof values.veryGoodHealth !== 'number') {
      values.veryGoodHealth = Number(values.veryGoodHealth);
    }
    if (values.goodHealth !== undefined && typeof values.goodHealth !== 'number') {
      values.goodHealth = Number(values.goodHealth);
    }
    if (values.fairHealth !== undefined && typeof values.fairHealth !== 'number') {
      values.fairHealth = Number(values.fairHealth);
    }
    if (values.badHealth !== undefined && typeof values.badHealth !== 'number') {
      values.badHealth = Number(values.badHealth);
    }
    if (values.veryBadHealth !== undefined && typeof values.veryBadHealth !== 'number') {
      values.veryBadHealth = Number(values.veryBadHealth);
    }

    const entity = {
      ...generalHealthEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...generalHealthEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.generalHealth.home.createOrEditLabel" data-cy="GeneralHealthCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.generalHealth.home.createOrEditLabel">Create or edit a GeneralHealth</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="general-health-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.generalHealth.geographicLevel')}
                id="general-health-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.generalHealth.date')}
                id="general-health-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.generalHealth.geography')}
                id="general-health-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.generalHealth.geographyCode')}
                id="general-health-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.generalHealth.totalAllUsualResidents')}
                id="general-health-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.generalHealth.veryGoodHealth')}
                id="general-health-veryGoodHealth"
                name="veryGoodHealth"
                data-cy="veryGoodHealth"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.generalHealth.goodHealth')}
                id="general-health-goodHealth"
                name="goodHealth"
                data-cy="goodHealth"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.generalHealth.fairHealth')}
                id="general-health-fairHealth"
                name="fairHealth"
                data-cy="fairHealth"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.generalHealth.badHealth')}
                id="general-health-badHealth"
                name="badHealth"
                data-cy="badHealth"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.generalHealth.veryBadHealth')}
                id="general-health-veryBadHealth"
                name="veryBadHealth"
                data-cy="veryBadHealth"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/general-health" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default GeneralHealthUpdate;
